const PathConstants = {
  HOME: "/",
  DASHBOARD: "/dashboard",
  HELP: "/help",
  LOGIN: "/login",
  DEMO_CREATION: "/democreation",

  // Roadmap items
  ROADMAP: "/roadmap",
  ROADMAP_CREATE: "/roadmap/create",
  ROADMAP_CONFIGURE: "/roadmap/configure/:roadmapItemId",
  ROADMAP_CONFIGURE_PREFIX: "/roadmap/configure/",

  // Release notes
  RELEASES: "/releases",
  RELEASES_CREATE: "/releases/create",
  RELEASES_CONFIGURE: "/releases/configure/:releaseNoteId",
  RELEASES_CONFIGURE_PREFIX: "/releases/configure/",

  // Feedback
  ADMIN_FEEDBACK: "/admin/feedback",

  // Chat
  CHAT_NEW: "/chat/new",
  CHAT: "/chat/:chatId",
  CHAT_LIST: "/chat/list",

  // Demo
  DEMO_TYPE_SELECT: "/demo/create",
  DEMO_CREATE: "/demo/create/form",
  DEMO_CONFIGURE: "/demo/configure/:demoId",
  DEMO_CONFIGURE_PREFIX: "/demo/configure/",
  DEMO_LIST: "/demos/:featureId",
  DEMO_FAVOURITES_LIST: "/demos/favourites",
  DEMO_SEARCH_LIST: "/demos/search",
  DEMO_PLAY_HISTORY: "/demos/history",
  ADMIN_DEMO_ATTRIBUTION: "/demos/attribution",
  DEMO_DETAILS: "/demo/details/:demoId/:language?/:vertical?",
  DEMO_DETAILS_PREFIX: "/demo/details/",
  DEMO_UPLOAD: "/demo/upload/:demoId/:variantId/:mediaType",
  DEMO_UPLOAD_PREFIX: "/demo/upload/",
  DEMO_PROJECT_BOARD: "/demo/project",

  // Variant
  VARIANT_CREATE: "/variant/create/:demoId",
  VARIANT_CREATE_PREFIX: "/variant/create/",
  VARIANT_CONFIGURE: "/variant/configure/:demoId/:variantId",
  VARIANT_PLAYER: "/variant/player/:demoId/:variantId/:variantVersion",
  VARIANT_PLAYER_PREFIX: "/variant/player/",
  VARIANT_CONFIGURE_PREFIX: "/variant/configure/",
  VARIANT_EDITOR: "/variant/edit/:demoId/:variantId",
  VARIANT_EDITOR_PREFIX: "/variant/edit/",
  VARIANT_VERSIONS_LIST: "/variant/versions/:demoId/:variantId",
  VARIANT_VERSION_PREFIX: "/variant/versions/",

  // Feature
  FEATURE_CREATE: "/feature/create",
  FEATURE_LIST: "/feature/list",
  FEATURE_CONFIGURE: "/feature/configure/:featureId",

  // Feedback requests
  FEEDBACK: "/feedback",
  FEEDBACK_LIST: "/feedback/list",
  FEEDBACK_CONFIGURE: "/feedback/configure/:feedbackId",
  FEEDBACK_CONFIGURE_PREFIX: "/feedback/configure/",

  // User
  USER_LIST: "/user/list",
  USER_CREATE: "/user/create",
  USER_IMPORT: "/user/import",
  USER_CONFIGURE: "/user/configure/:email/:userId",
  USER_CONFIGURE_PREFIX: "/user/configure/",

  // Partner domain listing
  PARTNER_DOMAIN_LIST: "/partner/domain/list",
  // Partner user approval list
  PARTNER_APPROVAL_LIST: "/partner/approval/list",

  // Admin
  ADMIN_DEMO_FORM_OPTIONS: "/admin/demoformoptions",
};

export default PathConstants;
